import React, { useState } from 'react'
import { Divider, Popover } from '@mui/material'
import { KeyboardArrowDown } from '@mui/icons-material'
import { semesterAndYearOptions } from 'keys/years'
import { semesters } from 'keys'
import SelectOption from 'components/Form/SelectOption'
import { LightButton } from 'styles/GlobalStyle'
import { SelectSemesterAndYearStyles } from 'components/SelectSemesterAndYear/Style'
import { styled as muiStyled } from '@mui/material/styles'
import { Box } from '@mui/material'
// todo Ayala- Replace with current Select from statistic page
const TriggerButton = muiStyled(Box)(() => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    cursor: 'pointer',
    padding: '0px 5px',
    border: 'none',
    background: 'transparent',
    fontSize: 14,
    userSelect: 'none',
    color: 'rgba(0,0,0,0.38)',
}))

const SelectCombinations = ({ years, semesters: selectedSemesters, onApply, yearOnly }) => {
    const [anchorEl, setAnchorEl] = useState(null)
    const [tempYears, setTempYears] = useState(years || [])
    const [tempSemesters, setTempSemesters] = useState(selectedSemesters || [])

    const open = Boolean(anchorEl)

    const handleOpen = (e) => {
        setTempYears(years || [])
        setTempSemesters(selectedSemesters || [])
        setAnchorEl(e.currentTarget)
    }

    const handleClose = () => setAnchorEl(null)

    const toggleYear = (year) => {
        setTempYears(prev =>
            prev.find(y => y.id === year.id)
                ? prev.filter(y => y.id !== year.id)
                : [...prev, year]
        )
    }

    const toggleSemester = (sem) => {
        setTempSemesters(prev =>
            prev.find(s => s.id === sem.id)
                ? prev.filter(s => s.id !== sem.id)
                : [...prev, sem]
        )
    }

    const handleApply = () => {
        onApply(tempYears, yearOnly ? [] : tempSemesters)
        handleClose()
    }

    const semesterShort = !yearOnly && selectedSemesters.map(s => s.name.split(' ')[0]).join(' - ')
    const label = years.length
        ? [semesterShort ? `${semesterShort} שנה` : null, ...years.map(y => y.name)].filter(Boolean).join(' | ')
        : yearOnly ? 'בחר שנה' : 'בחר שנה וסמסטרים'

    return (
        <>
            <TriggerButton onClick={handleOpen}>
                <span>{label}</span>
                <KeyboardArrowDown sx={{ fontSize: 18, color: 'rgba(0,0,0,0.54)', flexShrink: 0 }} />
            </TriggerButton>

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{ sx: { borderRadius: 2, boxShadow: '0 4px 20px rgba(0,0,0,0.12)', minWidth: 220 } }}
            >
                <SelectSemesterAndYearStyles sx={{ p: 1 }}>
                    <div className="title">שנת לימודים</div>
                    {semesterAndYearOptions.map(year => (
                        <SelectOption
                            key={year.id}
                            option={year}
                            selected={tempYears.some(y => y.id === year.id)}
                            onClick={toggleYear}
                            multiple
                            getLabel={opt => opt.name}
                        />
                    ))}
                    {!yearOnly && (
                        <>
                            <Divider sx={{ my: 1 }} />
                            <div className="title">סמסטר</div>
                            {semesters.map(sem => (
                                <SelectOption
                                    key={sem.id}
                                    option={sem}
                                    selected={tempSemesters.some(s => s.id === sem.id)}
                                    onClick={toggleSemester}
                                    multiple
                                    getLabel={opt => opt.name}
                                />
                            ))}
                        </>
                    )}
                    <div className="applied-button">
                        <LightButton
                            size="small"
                            action={handleApply}
                            disabled={!tempYears.length || (!yearOnly && !tempSemesters.length)}
                        >
                            החל
                        </LightButton>
                    </div>
                </SelectSemesterAndYearStyles>
            </Popover>
        </>
    )
}

export default SelectCombinations
